import React, { useState } from 'react';
import { MdPhone, MdLocationOn, MdHeadsetMic } from 'react-icons/md';
import './contact.css';

const Contact = () => {
  const [activeModal, setActiveModal] = useState(null);

  const closeModal = () => {
    setActiveModal(null);
    document.body.classList.remove("body--modal-active");
  };

  const openModal = (modalType) => {
    setActiveModal(modalType);
    document.body.classList.add("body--modal-active");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you! We will contact you soon.");
    closeModal();
  };

  return (
    <section className="contact">
      <div className=" contact__container">
        <h2 className="contact__heading">Contact us</h2>
        <p className="contact__subheading">
          Connect with the right client relationship and specialist teams to move you forward.
        </p>

        <div className="contact__grid">
          {/* Let us call you */}
          <div className="contact__card" onClick={() => openModal("callback")}>
            <div className="contact__icon">
              <MdHeadsetMic />
            </div>
            <div className="contact__content">
              <h4>Let us call you</h4>
              <p>Give us your contact details and we will call you back.</p>
            </div>
          </div>

          {/* Give us a call */}
          <div className="contact__card" onClick={() => openModal("call")}>
            <div className="contact__icon">
              <MdPhone />
            </div>
            <div className="contact__content">
              <h4>Give us a call</h4>
              <p>You can reach us 24/7 from Monday - Sunday.</p>
            </div>
          </div>

          {/* Location */}
          <div className="contact__card" onClick={() => openModal("address")}>
            <div className="contact__icon">
              <MdLocationOn />
            </div>
            <div className="contact__content">
              <h4>Location</h4>
              <p>Find our branch and visit us in person.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {activeModal && (
        <div className={`modal show`}>
          <div className="modal__content">
            <button className="modal__close" onClick={closeModal}>
              &times;
            </button>

            {activeModal === "callback" && (
              <form className="callback__form" onSubmit={handleSubmit}>
                <h3>Let us call you back</h3>
                <p>Fill in your information and let us call you:</p>
                <label htmlFor="title">Title</label>
                <select id="title" name="title" required>
                  <option value="">Select</option>
                  <option value="Mr">Mr</option>
                  <option value="Ms">Ms</option>
                </select>

                <label htmlFor="firstName">First name</label>
                <input type="text" id="firstName" name="firstName" placeholder="Enter your first name" required />

                <label htmlFor="surname">Surname</label>
                <input type="text" id="surname" name="surname" placeholder="Enter your surname" required />

                <label htmlFor="phone">Telephone Number</label>
                <input type="tel" id="phone" name="phone" placeholder="Enter your telephone number" required />

                <label htmlFor="email">Email address</label>
                <input type="email" id="email" name="email" placeholder="Enter your email address" required />

                <label htmlFor="query">Query / Comments</label>
                <textarea id="query" name="query" placeholder="Enter your query or comments" required></textarea>

                <button type="submit">Call me back</button>
              </form>
            )}

            {activeModal === "call" && (
              <div>
                <h3>Contact us</h3>
                <p>Let’s talk on the channels below:</p>
                <h4>Customer Care Centre</h4>
                <p>+1 416 949 6457</p>
                <h4>Email us</h4>
                <p>customer@layer3.com</p>
              </div>
            )}

            {activeModal === "address" && (
              <div>
                <h3>Branch Location</h3>
                <p>545 Oakwood Drive, Pickering, ON L1W 2M8, Canada</p>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default Contact;
